import * as Sentry from '@sentry/react';
import { recentFailedRequests, requestPath, FailedRequest } from './failedRequests';

export type ProblemReportContext = {
  app_version: string;
  build?: string;
  user_agent?: string;
  page_path: string;
  study_instance_uid?: string;
  series_instance_uid?: string;
  viewer_tab?: 'generalViewer' | 'views' | 'report';
  report_section?: string;
  error_tracker_event_id?: string;
  failed_requests: FailedRequest[];
};

const DICOM_UID = /^[0-9]+(\.[0-9]+)*$/;
const HEX_ID = /^[0-9a-f]{32}$/;
const SECTION = /^[a-z0-9_-]{1,32}$/;
const VIEWER_TABS = new Set(['views', 'report']);
const EXAM_PAGES = new Set(['/exam/viewer', '/sweep/viewer', '/realtime']);

export function buildReportContext(pathname: string, search: string): ProblemReportContext {
  const params = new URLSearchParams(search);
  const onExam = EXAM_PAGES.has(pathname);
  const studyUid = params.get('StudyInstanceUIDs')?.split(',')[0]?.trim();
  const seriesUid = params.get('SeriesInstanceUIDs')?.split(',')[0]?.trim();
  const validUid = (uid?: string) => !!uid && uid.length <= 64 && DICOM_UID.test(uid);
  const tab = params.get('tab');
  const section = params.get('reportSection');
  const eventId = Sentry.lastEventId();
  const build = process.env.BUILD_NUM;

  return {
    app_version: (process.env.VERSION_NUMBER || 'unknown').slice(0, 64),
    ...(build && build !== '0' ? { build: build.slice(0, 32) } : {}),
    user_agent: navigator.userAgent.slice(0, 255),
    page_path: requestPath(pathname) ?? '/',
    ...(onExam && validUid(studyUid) ? { study_instance_uid: studyUid } : {}),
    ...(onExam && validUid(studyUid) && validUid(seriesUid) ? { series_instance_uid: seriesUid } : {}),
    ...(onExam && pathname !== '/realtime' ? { viewer_tab: tab && VIEWER_TABS.has(tab) ? (tab as 'views' | 'report') : 'generalViewer' } : {}),
    ...(onExam && tab === 'report' && section && SECTION.test(section) ? { report_section: section } : {}),
    ...(eventId && HEX_ID.test(eventId) ? { error_tracker_event_id: eventId } : {}),
    failed_requests: recentFailedRequests(),
  };
}
